import { themeRegistry } from './theme-registry';

export function resolveTheme(themeId) {
	return themeRegistry[themeId] || themeRegistry.light;
}
